import React from "react";

const Footer = () => {
  return (
    <div className="bg-primary h-10 text-white flex items-center justify-center">
      <p className="text-xs">© 2023 BikeBikeBike</p>
    </div>
  );
};

export default Footer;
